import './Credibility.css';
import useReveal from './useReveal';
import useCountUp from './useCountUp';

// §5.04 — 4 metrics, 2×2 on mobile. Values/labels verbatim.
const METRICS = [
  { value: '17+',               label: 'Years experience' },
  { value: 'Aviation',          label: 'Ex-Cabin Crew, Kingfisher Airlines' },
  { value: '13 yrs',            label: 'Corporate leadership journey' },
  { value: 'VP-level',          label: 'Sales & Marketing leadership' },
  { value: 'Corporate Trainer', label: '& Facilitator' },
  { value: 'EI Coach',          label: 'Emotional Intelligence' },
  { value: 'POSH + POCSO',      label: 'Certified consultant' },
];

function Metric({ value, label }) {
  const [ref, display] = useCountUp(value);
  return (
    <div className="credibility__card">
      <div className="credibility__value" ref={ref}>{display}</div>
      <div className="credibility__label">{label}</div>
    </div>
  );
}

export default function Credibility() {
  const gridRef = useReveal({ stagger: 60, maxStaggered: 6 });

  return (
    <section className="credibility">
      <div className="container">
        <div className="credibility__grid" ref={gridRef}>
          {METRICS.map((m) => (
            <Metric key={m.label} value={m.value} label={m.label} />
          ))}
        </div>
      </div>
    </section>
  );
}
